import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { twJoin } from 'tailwind-merge';
import tinycolor from 'tinycolor2';
import twMerge from 'utils/twMerge';

type Props = {
    'data-testid'?: string;
    backgroundColor: string;
    fixedWidth?: boolean;
    flagLink?: string;
    isCustomLink?: boolean;
    textColor?: string | null;
    large?: boolean;
    className?: React.ComponentProps<'div'>['className'];
};

export const Flag: FC<Props> = ({
    children,
    large = false,
    fixedWidth = false,
    backgroundColor,
    'data-testid': testIdentifier = 'basic-flag',
    flagLink,
    isCustomLink = false,
    textColor,
    className,
}) => {
    const isDefaultVariant = backgroundColor === '#ffffff';
    const hasCustomTextColor = textColor !== null && textColor !== undefined;

    const flagTwClass = twJoin(
        'inline-flex justify-center items-center px-[0.4rem] py-[0.1rem] text-small font-medium web-transition whitespace-nowrap hover:no-underline cursor-pointer',
        fixedWidth && 'w-16',
        large && 'min-h-8',
        isDefaultVariant && 'border-solid border border-grayDarker',
        !hasCustomTextColor && (isDefaultVariant ? 'text-grayDark' : 'text-white'),
    );

    const colorStyles = {
        backgroundColor: isDefaultVariant ? '#fff' : tinycolor(backgroundColor).toString(),
        color: hasCustomTextColor ? tinycolor(textColor).toString() : undefined,
    };

    if (flagLink !== undefined) {
        return (
            <ExtendedNextLink className="no-underline" href={flagLink} type={isCustomLink ? undefined : 'flag'}>
                <div
                    className={twMerge(flagTwClass, className)}
                    data-testid={testIdentifier}
                    style={colorStyles}
                    onClick={(e) => e.stopPropagation()}
                >
                    {children}
                </div>
            </ExtendedNextLink>
        );
    }

    return (
        <div className={flagTwClass} data-testid={testIdentifier} style={colorStyles}>
            {children}
        </div>
    );
};
